import { Component, inject, Input } from '@angular/core';
import { DayTimeIntervalDTO, WeeklyScheduleDTO } from '../../services/api/api';
import { WeeklyScheduleService } from '../../services/date-time/weekly-schedule.service';
import { StringTransformationService } from '../../services/transformation-helper/string-transformation.service';

@Component({
  selector: 'sb-comp-weekly-schedule',
  templateUrl: './weekly-schedule.component.html',
  styleUrls: ['./weekly-schedule.component.scss'],
  standalone: false,
})
export class WeeklyScheduleComponent {
  private readonly stringTransformation = inject(StringTransformationService);

  @Input() weeklySchedule: WeeklyScheduleDTO;

  constructor(public weeklyScheduleService: WeeklyScheduleService) {}

  hourRangesToString(ranges: DayTimeIntervalDTO[]): string {
    return ranges
      .map(range => {
        return (
          this._hourAndMinuteToString(range.fromHour, range.fromMinute) +
          ' - ' +
          this._hourAndMinuteToString(range.tillHour, range.tillMinute)
        );
      })
      .join(', ');
  }

  _hourAndMinuteToString(hour: number, minute: number) {
    return this.stringTransformation.addLeadingZeros(hour, 2) + ':' + this.stringTransformation.addLeadingZeros(minute, 2);
  }
}
